import { useState } from "react";
import { motion } from "framer-motion";
import { List, X, Phone } from "@phosphor-icons/react";
import { LogoMark } from "@/components/Logo";
import { SITE } from "@/constants/site";

const LINKS = [
  { label: "Services", href: "#services" },
  { label: "Why Us", href: "#manifesto" },
  { label: "About", href: "#about" },
  { label: "Stories", href: "#testimonials" },
  { label: "EMI Calculator", href: "#emi-calculator" },
  { label: "Contact", href: "#contact" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, delay: 0.9, ease: [0.22, 1, 0.36, 1] }}
      className="fixed top-0 inset-x-0 z-50 bg-white/80 backdrop-blur-xl border-b border-black/5"
      data-testid="site-navbar"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-[72px] flex items-center justify-between">
        <a href="#top" className="flex items-center gap-2.5" data-testid="nav-logo">
          <LogoMark className="w-9 h-9" />
          <span className="font-serif text-lg font-semibold tracking-tight text-ink">{SITE.brand}</span>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <a key={l.href} href={l.href} data-testid={`nav-link-${l.label.toLowerCase().replace(" ", "-")}`}
              className="text-sm font-medium text-moss hover:text-forest transition-colors duration-300">
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-4">
          <a href={`tel:${SITE.phoneHref}`} data-testid="nav-call-link"
            className="flex items-center gap-2 text-sm font-semibold text-forest hover:text-forest-soft transition-colors duration-300">
            <Phone size={16} weight="bold" /> {SITE.phoneDisplay}
          </a>
          <motion.a href="#contact" data-testid="nav-quote-button" whileTap={{ scale: 0.97 }}
            className="bg-forest text-white text-sm font-semibold px-5 py-2.5 rounded-full hover:bg-forest-soft transition-colors duration-300">
            Get a Quote
          </motion.a>
        </div>

        <button className="md:hidden text-ink" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle" aria-label="Toggle menu">
          {open ? <X size={24} /> : <List size={24} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-white/95 backdrop-blur-xl border-t border-black/5 px-6 py-6 flex flex-col gap-4" data-testid="nav-mobile-menu">
          {LINKS.map((l) => (
            <a key={l.href} href={l.href} onClick={() => setOpen(false)}
              className="text-base font-medium text-ink">{l.label}</a>
          ))}
          <a href="#contact" onClick={() => setOpen(false)} data-testid="nav-mobile-quote-button"
            className="bg-forest text-white text-center text-sm font-semibold px-5 py-3 rounded-full">
            Get a Quote
          </a>
        </div>
      )}
    </motion.header>
  );
};
